'use strict';

var forEach = Array.prototype.forEach, create = Object.create;

module.exports = function (arg/*, …args*/) {
	var set = create(null);
	forEach.call(arguments, function (name) { set[name] = true; });
	return set;
};



//////////////////
// WEBPACK FOOTER
// ../~/es5-ext/object/primitive-set.js
// module id = 175
// module chunks = 0